
import { useEffect } from "react";
import { CoachesList } from "@/components/CoachesList";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { initializeGtag } from "@/utils/gtag";
import { useNavigation } from "@/hooks/use-navigation";

export const SelectCoach = () => {
  const navigate = useNavigation();

  useEffect(() => {
    initializeGtag();
  }, []);

  const handleCoachSelect = (coach: any) => {
    // Store selected coach in localStorage
    localStorage.setItem('selectedCoach', JSON.stringify(coach));
    // Navigate to user details page
    navigate('/user-details');
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-brand-secondary to-brand-primary">
      <div className="w-full bg-background">
        <div className="container mx-auto">
          <Card className="mb-6">
            <CardHeader>
              <CardTitle>Koç Seçimi</CardTitle>
              <CardDescription>
                Size en uygun koçu seçerek mentörlük programına başlayın
              </CardDescription>
            </CardHeader>
          </Card>
          
          <CoachesList 
            showFilters={true}
            onCoachSelect={handleCoachSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectCoach;
